export default "__VITE_ASSET__2f997747__"